export default "__VITE_ASSET__9a10f1c0__"